import * as React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";

const TemplateCardSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="aspect-square h-full w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-16" />
    </div>
  );
};

export const TemplatesGridSkeleton: React.FC<{
  cardCount?: number;
}> = ({ cardCount = 7 }) => {
  return (
    <div
      className="no-scrollbar flex max-h-screen flex-1 cursor-default flex-col overflow-scroll pb-72 pr-1"
      id="templates-grid"
    >
      <div className="grid grid-cols-1 gap-x-2 gap-y-5 min-[900px]:grid-cols-2 min-[1500px]:grid-cols-3 min-[2400px]:grid-cols-4">
        {Array.from({ length: cardCount }).map((_, index) => (
          <TemplateCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};
